import { actionTypes } from '../constants/actionTypes';

const initState = {
    data: [],
    error: null,
    loading: true
};

export default function (state = initState, action) {
    const {type, payload} = action;
    switch (type) {
        case actionTypes.FETCH_WP_USER: {
            return Object.assign({}, state, {data: [], loading: true});
        }

        case actionTypes.FETCH_USER_WP_SUCCESS:
        case actionTypes.FETCH_USER_WP_FAIL: {
            return Object.assign({}, state, payload);
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/usersWP.tsx